/* HOW IT WORKS */
export const HOW_IT_WORK_GET_LIST = 'HOW_IT_WORK_GET_LIST';
export const HOW_IT_WORK_GET_LIST_SUCCESS = 'HOW_IT_WORK_GET_LIST_SUCCESS';
export const HOW_IT_WORK_GET_LIST_ERROR = 'HOW_IT_WORK_GET_LIST_ERROR';


/* HOW IT WORKS */
export const TESTIMONIAL_GET_LIST = 'TESTIMONIAL_GET_LIST';
export const TESTIMONIAL_GET_LIST_SUCCESS = 'TESTIMONIAL_GET_LIST_SUCCESS';
export const TESTIMONIAL_GET_LIST_ERROR = 'TESTIMONIAL_GET_LIST_ERROR';

/* OUR VEHICLES WORKS */
export const OURVEHICLE_GET_LIST = 'OURVEHICLE_GET_LIST';
export const OURVEHICLE_GET_LIST_SUCCESS = 'OURVEHICLE_GET_LIST_SUCCESS';
export const OURVEHICLE_GET_LIST_ERROR = 'OURVEHICLE_GET_LIST_ERROR';

/* about-us content WORKS */
export const ABOUTUSCONTENT_GET_LIST = 'ABOUTUSCONTENT_GET_LIST';
export const ABOUTUSCONTENT_GET_LIST_SUCCESS = 'ABOUTUSCONTENT_GET_LIST_SUCCESS';
export const ABOUTUSCONTENT_GET_LIST_ERROR = 'ABOUTUSCONTENT_GET_LIST_ERROR';

/* about-banner content WORKS */
export const ABOUTBANNER_GET_LIST = 'ABOUTBANNER_GET_LIST';
export const ABOUTBANNER_GET_LIST_SUCCESS = 'ABOUTBANNER_GET_LIST_SUCCESS';
export const ABOUTBANNER_GET_LIST_ERROR = 'ABOUTBANNER_GET_LIST_ERROR';

/* about-us Values content WORKS */
export const VALUES_GET_LIST = 'VALUES_GET_LIST';
export const VALUES_GET_LIST_SUCCESS = 'VALUES_GET_LIST_SUCCESS';
export const VALUES_GET_LIST_ERROR = 'VALUES_GET_LIST_ERROR';

/* WHY CHOOSE CARS */
export const WHY_CHOOSE_CARS_LIST = 'WHY_CHOOSE_CARS_LIST';
export const WHY_CHOOSE_CARS_SUCCESS = 'WHY_CHOOSE_CARS_SUCCESS';
export const WHY_CHOOSE_CARS_ERROR = 'WHY_CHOOSE_CARS_ERROR';

//Sarada : 10-10-2022
/* FAQs */
export const FAQs_GET_LIST = 'FAQs_GET_LIST';
export const FAQs_GET_LIST_SUCCESS = 'FAQs_GET_LIST_SUCCESS';
export const FAQs_GET_LIST_ERROR = 'FAQs_GET_LIST_ERROR';

/*HOME OFFERS */
export const HOME_OFFERS_LIST = 'HOME_OFFERS_LIST';
export const HOME_OFFERS_SUCCESS = 'HOME_OFFERS_SUCCESS';
export const HOME_OFFERS_ERROR = 'HOME_OFFERS_ERROR';

/* About Info */
export const ABOUT_INFO_LIST = ' ABOUT_INFO_LIST';
export const ABOUT_INFO_SUCCESS = ' ABOUT_INFO_SUCCESS';
export const ABOUT_INFO_ERROR = ' ABOUT_INFO_ERROR';
